import React, { useRef, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import settingsStyles from "src/Assets/css/settings/settings.module.css";
import Sidebaroptions from "src/Components/SidebarOption";
import Notifications from "src/pages/Notifications";
import HeaderAfterSignIn from "../../Components/Header/header";
import logo from "src/Assets/images/LandingPageImages/skopic-image.png";
import Cookies from "js-cookie";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";
import API from "../../network";
import "./index.css";
import { useSelector } from "react-redux";

const defaultState = {
  google: false,
  safari: false,
  mozilla: false,
  opera: false,
  internetExplorer: false,
};

function CookiesComponent() {
  const googleRef = useRef(null);
  const safariRef = useRef(null);
  const mozillaRef = useRef(null);
  const operaRef = useRef(null);
  const explorerRef = useRef(null);
  const [signInStatus, setSignInStatus] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const status = Cookies.get("signInStatus");
    setSignInStatus(status);
  }, []);

  const [isActive, setIsActive] = useState({
    ...defaultState,
    google: true,
  });

  const clickHandler = (key) => {
    setIsActive({
      ...defaultState,
      [key]: true,
    });

    scrollToView(key);
  };

  const communityContext = useContext(CommunityContext);
  const settingsData = useSelector((state) => state.voteupReducer.settingsData);

  const scrollToView = (key) => {
    if (key === "google" && googleRef.current) {
      googleRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "safari" && safariRef.current) {
      safariRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "mozilla" && mozillaRef.current) {
      mozillaRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "opera" && operaRef.current) {
      operaRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "internetExplorer" && explorerRef.current) {
      explorerRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onSkopicClick = async () => {
    try {
      const response = await API.changeCommunity(
        settingsData?.userTenant,
        settingsData?.userTenantId
      );
      if (response) {
        communityContext?.onChangeCommunity({
          tenantId: settingsData?.userTenantId,
          tenantName: settingsData?.userTenant,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const [isNotificationSelected, setIsNotificationSelected] = useState(false);

  const showHideNotifications = () => {
    setIsNotificationSelected(!isNotificationSelected);
  };

  return (
    <div className="footer-main-container" style={{marginTop: "50px"}}>
      {isNotificationSelected ? (
        <div className={`col-sm-3  ${settingsStyles.notifications}`}>
          <div className={settingsStyles.notificationscroll}>
            <Notifications />
          </div>
        </div>
      ) : null}
      <div>
        {signInStatus === "true" ? (
          <HeaderAfterSignIn onSkopicClick={onSkopicClick} />
        ) : (
          <div className={settingsStyles.headerContainer}>
            <Link to={"/"}>
              <div>
                <img src={logo} alt="Skopic-Logo" width={90} height={48} />
              </div>
            </Link>
          </div>
        )}
        <div className="careers-main-container">
          <div className="page-navigation-options-container">
            {/* <h3>Cookies</h3> */}
            <div className="main-heading-container">
              <h3 className="main-heading">Cookies</h3>
            </div>
            <div className="page-navigation-options">
              <div className="page-options-content">
                <Sidebaroptions
                  active={isActive.google}
                  text="Google"
                  onSidebaroptionClick={() => clickHandler("google")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.safari}
                  text="Safari"
                  onSidebaroptionClick={() => clickHandler("safari")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.mozilla}
                  text="Mozilla"
                  onSidebaroptionClick={() => clickHandler("mozilla")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.opera}
                  text="Opera"
                  onSidebaroptionClick={() => clickHandler("opera")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.internetExplorer}
                  text="Internet Explorer"
                  onSidebaroptionClick={() => clickHandler("internetExplorer")}
                />
              </div>
            </div>
          </div>
          <div className="careers-content-container">
            <div
              ref={googleRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              }  ${isActive.google && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Google Chrome</h5>
              <ol>
                <li>
                  On your computer, open <strong>Chrome.</strong>
                </li>
                <br />
                <li>
                  At the top right, click <strong>Settings.</strong>
                </li>
                <br />
                <li>
                  At the bottom, click <strong>Preferences.</strong>
                </li>
                <br />
                <li>
                  Under <strong>Privacy and Security</strong>, click{" "}
                  <strong>Content Settings</strong>
                </li>
                <br />
                <li>
                  Click <strong>Preferences.</strong>
                </li>
                <br />
                <li>
                  From here, you can:
                  <br />
                  Turn on cookies: Next to Blocked,turn on the switch.
                  <br />
                  Turn off cookies: Turn off Allow sites to save and read cookie
                  data.
                </li>
              </ol>
            </div>
            <div
              ref={safariRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              }  ${isActive.safari && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Safari</h5>
              <ol>
                <li>
                  On your compuer, open <strong>Safari.</strong>
                </li>
                <br />
                <li>
                  At the top right, click <strong>More</strong>and then{" "}
                  <strong>Settings</strong>
                </li>
                <br />
                <li>
                  At the bottom, click <strong>Advanced.</strong>
                </li>
                <br />
                <li>
                  Under <strong>Privacy</strong>
                </li>
                <br />
                <li>
                  You will see <strong>Block Cookies.</strong> Section
                </li>
                <br />
                <li>
                  Click on <strong>Never</strong> radio button under{" "}
                  <strong>Block Cookies.</strong>
                </li>
                <br />
                <li> Reload your browser, Cookies will be Enabled</li>
              </ol>
            </div>
            <div
              ref={mozillaRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.mozilla && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Mozilla</h5>
              <ol>
                <li>
                  On your compuer, open <strong>Firefox.</strong>
                </li>
                <br />
                <li>
                  Click on the <strong>Tools Menu.</strong>
                </li>
                <br />
                <li>
                  Click on <strong>Options.</strong>
                </li>
                <br />
                <li>
                  Select <strong>Privacy Settings</strong>
                </li>
                <br />
                <li>
                  If you want no restrictions,tick{" "}
                  <strong>Accept cookies from sites</strong>
                </li>
                <br />
                <li>
                  If you want to set some restrictions, unclick{" "}
                  <strong>Accept cookies from sites.</strong>
                </li>
                <br />
              </ol>
            </div>
            <div
              ref={operaRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.opera && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Opera</h5>
              <ol>
                <li>
                  On your compuer, open <strong>Opera.</strong>
                </li>
                <br />
                <li>
                  Click on the <strong>Tools</strong> menu{" "}
                  <strong>Opera</strong>
                </li>
                <br />
                <li>
                  Click on <strong>Preferences.</strong>
                </li>
                <br />
                <li>
                  Change to the <strong>Advanced</strong>tab,and then go to the{" "}
                  <strong>Cookie</strong> section.
                </li>
                <br />
                <li>
                  Select{" "}
                  <strong>Accept cookies only from the site I visit</strong> or{" "}
                  <strong>Accept cookies</strong>
                </li>
                <br />
                <li>
                  Ensure <strong>Delete new cookies when exiting Opera</strong>{" "}
                  is not ticked.
                </li>
              </ol>
            </div>
            <div
              ref={explorerRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.internetExplorer && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Internet Explorer</h5>
              <ol>
                <li>
                  On your compuer, open <strong>IE.</strong>
                </li>
                <br />
                <li>
                  Click the <strong>Tools Button</strong>
                </li>
                <br />
                <li>
                  Next click <strong>Internet Options</strong> and select the{" "}
                  <strong>Privacy</strong> tab
                </li>
                <br />
                <li>
                  Under <strong>Settings</strong>
                </li>
                <br />
                <li>
                  Move the slider to the top to block all cookies or to the
                  bottom to allow all cookies
                </li>
                <br />
                <li>
                  Click <strong>Apply</strong>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookiesComponent;
